import axios from "axios";
import jwt_decode from "jwt-decode";

/* eslint-disable */
const state = {
    AuthToken: null,
    AvatarUrl: '',
    FirstName: '',
    LastName: '',
    RefreshToken: '',
    RememberMe: true,
    Email: '',
    tokenInformation: {},
    userId: null,
    expiration: '',
};
let refreshTokenPromise = null;

const getters = {
    isAuthenticated: state => !!state.AuthToken,
    isRememberMe: state => state.RememberMe,
    getUser: state => state.user,
    getEmail: state => state.email,
    getToken: state => state.AuthToken,
    getRefreshToken: state => state.RefreshToken,
    getAvatar: state => state.AvatarUrl,
    getUserId: state => state.userId,
    getExpiration: state => state.expiration,

};
const actions = {
    async login({commit}, user) {
        const response = await axios.post('token', user, {timeout: 60000});
        await commit('setUser', {...response.data.Result, email: user.email});
        sessionStorage.setItem('newSession', true);
    },
    async loginThirdParty({commit, rootGetters, dispatch}, payload) {
        return await axios.post(rootGetters.getUrl('loginThirdParty'),
            payload).then((response) => {
            commit('setUser', response.data.Result);
            return {status: response.status};
        }, (err) => {
            return {status: err.response.status, message: err.response.data.ErrorMessages};
        });
    },
    async acceptInvitationThirdParty({commit, rootGetters, dispatch}, payload) {
        return await axios.put(rootGetters.getUrl('acceptInvitationThirdParty'),
            payload).then((response) => {
            return {status: response.status};
        }, (err) => {
            return {status: err.response.status, message: err.response.data.ErrorMessages};
        });
    },
    async loginApple({commit, rootGetters, dispatch}, payload) {
        return await axios.post(rootGetters.getUrl('loginApple'),
            payload).then((response) => {
            return {status: response.status};
        }, (err) => {
            return {status: err.response.status, message: err.response.data.errorMessages};
        });
    },
    async acceptInvitationApple({commit, rootGetters, dispatch}, payload) {
        return await axios.put(rootGetters.getUrl('acceptInvitationApple'),
            payload).then((response) => {
            return {status: response.status};
        }, (err) => {
            return {status: err.response.status, message: err.response.data.errorMessages};
        });
    },
    async logout({commit, dispatch}) {
        let user = null;
        commit('logout', user);
        sessionStorage.removeItem('newSession');
        dispatch('removeOrganization');
    },
    async removeTokens({commit}) {
        commit('removeTokens');
    },
    refreshToken({commit, rootGetters}) {
        const url = rootGetters.getUrl('token');
        if (!rootGetters.isAuthenticated) {
            return;
        }
        if (refreshTokenPromise) {
            return refreshTokenPromise;
        }
        let refreshToken = rootGetters.getRefreshToken;

        try {
            const currentDate = Date.parse(rootGetters.getExpiration),
                vuex = JSON.parse(ls.get('vuex')),
                storageDate = Date.parse(vuex.auth.expiration);
            if (storageDate > currentDate) {
                refreshToken = vuex.auth.RefreshToken;
            }

        } catch {
        }
        refreshTokenPromise = axios.put(url, refreshToken)
            .then((response) => {
                commit('setUser', response.data.Result);
                refreshTokenPromise = null;
            });
        return refreshTokenPromise;
    },
    async setRememberMe({commit}, rememberMe) {
        commit('setRememberMe', rememberMe);
    },
    async setTokenInformation({rootGetters, commit, dispatch}, payload) {
        const tokenInformation = jwt_decode(rootGetters.getToken);
        await commit('setTokenInformation', tokenInformation);
        if (payload && payload.removeManager) {
            await dispatch('setManager', {
                organizationType: rootGetters.getOrganizationType,
                organizationId: rootGetters.getOrganizationId,
                organizationName: rootGetters.getOrganizationName,
                savePrevious: true,
            });
        }
    },
    setLoader({commit}, loading) {
        commit('setLoader', loading);
    }
};
const mutations = {
    setUser(state, user) {
        state.AuthToken = user.AuthToken;
        state.RefreshToken = user.RefreshToken;
        state.FirstName = user.FirstName;
        state.LastName = user.LastName;
        state.AvatarUrl = user.AvatarUrl ? user.AvatarUrl + '?t=' + new Date().getTime() : user.AvatarUrl;
        state.userId = parseInt(jwt_decode(user.AuthToken)['nameid']);
        state.expiration = parseInt(jwt_decode(user.AuthToken)['exp']);
    },
    removeTokens(state) {
        if (state.user) {
            state.user.accessToken = null;
            state.user.refreshToken = null;
        }
    },
    setPosts(state, posts) {
        state.posts = posts;
    },
    logout(state) {
        state.AuthToken = null;
        state.RefreshToken = null;
        state.FirstName = '';
        state.LastName = '';
        state.AvatarUrl = '';
    },
    setRememberMe(state, rememberMe) {
        state.RememberMe = rememberMe;
    },
    setTokenInformation(state, tokenInformation) {
        state.tokenInformation = tokenInformation;
    },
    setLoader(state, loading) {
        state.loading = loading;
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};